/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_empty-state': {
    width: 512,
    height: 512,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M19.5 24h-15A2.503 2.503 0 012 21.5v-19C2 1.122 3.122 0 4.5 0h15C20.878 0 22 1.122 22 2.5v19c0 1.378-1.122 2.5-2.5 2.5zM4.5 1C3.673 1 3 1.673 3 2.5v19c0 .827.673 1.5 1.5 1.5h15c.827 0 1.5-.673 1.5-1.5v-19c0-.827-.673-1.5-1.5-1.5z"/><path pid="1" d="M18.5 21h-13a.5.5 0 01-.5-.5v-12a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v12a.5.5 0 01-.5.5zM6 20h12V9H6z"/><path pid="2" d="M9.5 21a.5.5 0 01-.5-.5v-12a.5.5 0 011 0v12a.5.5 0 01-.5.5z"/><path pid="3" d="M18.5 12h-13a.5.5 0 010-1h13a.5.5 0 010 1zM18.5 15h-13a.5.5 0 010-1h13a.5.5 0 010 1zM18.5 18h-13a.5.5 0 010-1h13a.5.5 0 010 1z"/>'
  }
})
